import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import DateFormatter from '../../Shared/DateFormatter';
import { useContext, useState } from 'react';
import * as fileService from '../services/fileService';
import * as applicationService from "../services/applicationService";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { Statuses } from '../../Shared/statuses';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import Swal from 'sweetalert2';
import { AdminContext } from '../../contexts/AdminContext';
import { CancelApplicationAfterExpRank, confirmApplication, denyApplication, denyCancellationApplication } from '../services/RankingService';
import { ParameterContext } from '../../contexts/ParameterContext';
import { MobileContext } from '../../contexts/MobileContext';



export const RegNumSearchItem = ({ regNum, action, recentRanking, cleanFilterOptions, isOpenForAccepting, isOpenForRegister }) => {
    const [visible, setVisible] = useState({});
    const [hdata, setHdata] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { user } = useContext(AuthContext)
    const { cleanRegNums, changeRegNums } = useContext(AdminContext);
    const { parameters } = useContext(ParameterContext);
    const { isOnMobile } = useContext(MobileContext);
    const stop_reg_dir = parameters.nomParameters.find(x => x.param_name == 'STOP_REG_DIR').value;

    const toggleDialog = (id, openNow) => {
        setVisible(prev => ({ ...prev, [id]: !prev[id] }));

        const populate = async () => {
            try {
                applicationService.getAllApplicationHistory(id)
                    .then((res) => {
                        setHdata(res);
                    })
            } catch (error) {
                console.error('Error fetching data:', error.message);
            }
        };

        if (openNow) {
            populate();

        }
    };

    const handleButtonClick = (e, id, regNumUserDzId) => {
        e.preventDefault();

        if (user.role === 'Director' && (regNumUserDzId === -1 || regNumUserDzId == 0)) {
            Swal.fire({
                title: 'Внимание !',
                text: `Може да направите последваща редакция само ${parameters.nomParameters.find(x => x.param_name == "ADM_REG").value}!`,
                icon: 'warning',
                confirmButtonText: 'Ok'
            });

            return;
        }

        navigate(`/schadm/edit/${id}`);
    };

    const cancellationDeclaration = (e, id) => {
        e.preventDefault();
        setLoading(true);

        applicationService.cancellationDeclaration(id)
            .then((data) => {
                if (data.status == 400) {
                    Swal.fire({
                        title: 'Внимание!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                } else {
                    if (data) {
                        window.open(data, '_blank');
                    }
                }
                setLoading(false);
            })
            .catch((err) => {
                Swal.fire({
                    title: 'Внимание!',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'ОК'
                })
                setLoading(false);
            })
    }

    const cancellationApplication = (e, id) => {
        e.preventDefault();
        setLoading(true);

        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да анулирате заявление №${id} на дете ${regNum.child.chilD_NAME}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                applicationService.cancellationApplication(id)
                    .then((data) => {
                        if (data.status == 400) {
                            Swal.fire({
                                title: 'Внимание!',
                                text: data.message,
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        } else {
                            debugger
                            Swal.fire({
                                title: "Анулирано",
                                text: `Заявление №${id} на дете ${regNum.child.chilD_NAME} е анулирано успешно`,
                                icon: "success"
                            });
                            if (data) {
                                window.open(data, '_blank');
                            }
                            cleanFilterOptions();
                            cleanRegNums();
                        }
                        setLoading(false);
                    })

            }
        });
        setLoading(false);
    }

    const confirm = (e, id) => {
        e.preventDefault();
        setLoading(true);

        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да потвърдите заявление №${id} на дете ${regNum.child.chilD_NAME}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                confirmApplication(id, user.role == 'Director' && user.school.id)
                    .then((data) => {
                        if (data.status == 400) {
                            Swal.fire({
                                title: 'Внимание!',
                                text: data.message,
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        } else {
                            Swal.fire({
                                title: "Потвърдено",
                                text: `Заявление №${id} на дете ${regNum.child.chilD_NAME} е записано успешно`,
                                icon: "success"
                            });

                            cleanFilterOptions();
                            //cleanRegNums();
                            changeRegNums(id, 4);
                        }
                        setLoading(false);
                    })

            }
        });
        setLoading(false);
    }

    const deny = (e, id) => {
        e.preventDefault();
        setLoading(true);

        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да откажете прием на заявление №${id} на дете ${regNum.child.chilD_NAME}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                denyApplication(id, user.role == 'Director' && user.school.id)
                    .then((data) => {
                        if (data.status == 400) {
                            Swal.fire({
                                title: 'Внимание!',
                                text: data.message,
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        } else {
                            Swal.fire({
                                title: "Потвърдено",
                                text: `Заявление №${id} на дете ${regNum.child.chilD_NAME} е отказано успешно`,
                                icon: "success"
                            });

                            cleanFilterOptions();
                            //cleanRegNums();
                            changeRegNums(id, 9);
                        }
                        setLoading(false);
                    })
                    .catch((err) => {

                        Swal.fire({
                            title: 'Внимание!',
                            text: err.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    })

            }
        });
        setLoading(false);
    }

    const denyCancelledApplication = (e, id) => {
        e.preventDefault();
        setLoading(true);

        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да откажете заявление №${id} на дете ${regNum.child.chilD_NAME}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                denyCancellationApplication(id, user.role == 'Director' && user.school.id)
                    .then((data) => {
                        if (data.status == 400) {
                            Swal.fire({
                                title: 'Внимание!',
                                text: data.message,
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        } else {
                            Swal.fire({
                                title: "Потвърдено",
                                text: `Заявление №${id} на дете ${regNum.child.chilD_NAME} е върнато към класирани успешно`,
                                icon: "success"
                            });

                            cleanFilterOptions();
                            //cleanRegNums();
                            changeRegNums(id, 1);
                        }
                        setLoading(false);
                    })
                    .catch((err) => {

                        Swal.fire({
                            title: 'Внимание!',
                            text: err.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    })

            }
        });
        setLoading(false);
    }

    const CancelApplicationAfterExiredRanking = (e, id) => {
        e.preventDefault();
        setLoading(true);

        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да отпишете  заявление №${id} на дете ${regNum.child.chilD_NAME}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                CancelApplicationAfterExpRank(id, user.role == 'Director' && user.school.id)
                    .then((data) => {
                        if (data.status == 400) {
                            Swal.fire({
                                title: 'Внимание!',
                                text: data.message,
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        } else {
                            Swal.fire({
                                title: "Потвърдено",
                                text: `Заявление №${id} на дете ${regNum.child.chilD_NAME} е отписано успешно`,
                                icon: "success"
                            });

                            cleanFilterOptions();
                            cleanRegNums();
                        }
                        setLoading(false);
                    })
                    .catch((err) => {

                        Swal.fire({
                            title: 'Внимание!',
                            text: err.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    })

            }
        });
        setLoading(false);
    }

    const getHistoryPdf = async (hid) => {

        const data = {
            "historyId": hid
        }

        const populate = async () => {
            try {
                setLoading(true);

                let downloadUrl = await fileService.generateHistoryPdf(data);

                if (downloadUrl) {
                    if (isOnMobile) {
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = 'document.pdf';
                        link.click();
                    } else {
                        const newTab = window.open(downloadUrl, '_blank');
                        if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                            console.error('Error: The browser blocked opening a new tab.');
                            Swal.fire({
                                title: 'Браузърът блокира отварянето на PDF файла.',
                                text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                                icon: 'error',
                                confirmButtonText: 'ОК'
                            })
                        }
                    }
                }
                setLoading(false);

            } catch (error) {
                console.error('Error fetching PDF:', error);
            }
        };

        populate();
    };

    const getdataPDF = async (regId) => {
        try {
            setLoading(true);

            let downloadUrl = await fileService.getApplicationPDF({ regId });

            if (downloadUrl) {
                if (isOnMobile) {
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = 'document.pdf';
                    link.click();
                } else {
                    const newTab = window.open(downloadUrl, '_blank');
                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                        console.error('Error: The browser blocked opening a new tab.');
                        Swal.fire({
                            title: 'Браузърът блокира отварянето на PDF файла.',
                            text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    }
                }
            }
            setLoading(false);

        } catch (error) {
            console.error('Error fetching PDF:', error);
        }
    };

    return (
        <div className={`card d-flex flex-row flex-wrap gap-4 w-100 justify-content-start align-items-center p-2 ${regNum.status == 4 ? "bg-green" : regNum.status == 9 || regNum.status == 2 ? "bg-red" : ""} p-305-mob`}>
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <p className="text-start  w-10 m-0 w-100-mob w-30-l">Заявление №: <b>{regNum.regnumbeR_ID}</b></p>
            <p className="text-start text-end-l text-start-mob w-20 m-0 w-100-mob w-65-l">Име на дете: <b>{regNum.child.chilD_NAME}</b></p>
            <p className="text-start w-12 m-0 w-100-mob w-30-l">ЕГН/ЛНЧ на дете: <b>{regNum.egn}</b></p>
            <p className="text-start text-end-l text-start-mob w-10 m-0 w-100-mob w-65-l">Статус:&nbsp;
                <b>
                    {
                        recentRanking && recentRanking.iS_FINAL == 0 && regNum.status == 1
                            ? Statuses[0]
                            : Statuses[regNum.status]
                    }
                </b>
            </p>

            <div className="d-flex flex-wrap gap-2 w-40 p-1 w-100-mob w-100-l just-end-l">

                <Button label="История" icon="pi pi-history" className='btn-hist w-100-mob' onClick={() => toggleDialog(regNum.regnumbeR_ID, true)} id={`b${regNum.regnumbeR_ID}`} />
                <Dialog header={`История на заявление № ${regNum.regnumbeR_ID}`} visible={visible[regNum.regnumbeR_ID] || false} className="w-100-mob" style={{ width: '50vw' }} onHide={() => toggleDialog(regNum.regnumbeR_ID)} id={`d${regNum.regnumbeR_ID}`}>
                    <table className="table table-bordered table-responsive-stack mt-1">
                        <thead>
                            <tr>
                                <th className="text-rajon">Дата</th>
                                <th className="text-rajon">Действие</th>
                                <th className="text-rajon">Забележка</th>
                            </tr>
                        </thead>
                        <tbody>{hdata && hdata.map((item) => (
                            <tr key={item.id}>
                                <td><DateFormatter dateString={item.actioN_DATE_TIME} /></td>
                                <td>{item.action}</td>
                                <td>
                                    {(item.actioN_ID === 0 || item.actioN_ID === 30) &&
                                        <td><Button label="Виж" icon="pi pi-file-pdf" severity="danger" raised onClick={() => getHistoryPdf(item.historY_ID)} className='btn-prim' /></td>
                                    }
                                </td>
                            </tr>
                        ))}</tbody>
                    </table>
                </Dialog>

                <Button label="Виж заявление" icon="pi pi-file-pdf" raised onClick={() => getdataPDF(regNum.regnumbeR_ID)} className='btn-prim w-100-mob' />
                {action == 'edit' && regNum.status != '2' && regNum.status != '1' && regNum.status != '4' && regNum.status != '8' && isOpenForRegister ? (
                    <div onClick={(e) => handleButtonClick(e, regNum.regnumbeR_ID, regNum.user?.dzId)} className="w-100-mob">
                        <Button
                            label="Редакция"
                            icon="pi pi-user-edit"
                            severity="success"
                            onClick={(e) => handleButtonClick(e, regNum.regnumbeR_ID, regNum.user?.dzId)}
                            raised
                            className='btn-prim-green w-100-mob'
                            disabled={
                                (user.role === 'Director' && (regNum.user?.dzId === -1 || regNum.user?.dzId === 0)) ||
                                (user.role === 'Director' && stop_reg_dir == 1) ||
                                isOpenForAccepting
                            }
                        />
                    </div>
                ) : action === 'cancel' && (regNum.status == '0') ? (
                    <Button
                        label="Анулирай"
                        icon="pi pi-times"
                        severity="danger"
                        onClick={(e) => cancellationApplication(e, regNum.regnumbeR_ID)}
                        raised
                        className='btn-prim-red w-100-mob'
                        disabled={

                            (user.role === 'Director' && stop_reg_dir == 1) ||
                            isOpenForAccepting ||
                            !isOpenForRegister
                        }

                    />
                ) : (action === 'cancel' || action == 'edit') && (regNum.status == '2') ? (
                    <Button
                        label="Декларация"
                        icon="pi pi-file-pdf"
                        severity="danger"
                        onClick={(e) => cancellationDeclaration(e, regNum.regnumbeR_ID)}
                        raised
                        className='btn-prim-red w-100-mob'
                        disabled={

                            (user.role === 'Director' && stop_reg_dir == 1) ||
                            isOpenForAccepting ||
                            !isOpenForRegister
                        }

                    />
                ) : action === 'confirm' && regNum.status == '1' ? (
                    <>
                        <Button
                            label="Потвърди"
                            icon="pi pi-check"
                            severity="danger"
                            raised
                            className='btn-prim-confirm w-100-mob'
                            onClick={(e) => confirm(e, regNum.regnumbeR_ID)}
                        />
                        <Button
                            label="Откажи"
                            icon="pi pi-times-circle"
                            severity="danger"
                            raised
                            className='btn-prim-deny w-100-mob'
                            onClick={(e) => deny(e, regNum.regnumbeR_ID)}
                        />
                    </>
                ) : action === 'confirm' && regNum.status == '9' ? (
                    <Button
                        label="Анулирай отказ"
                        icon="pi pi-undo"
                        severity="danger"
                        raised
                        className='btn-prim-red w-100-mob'
                        onClick={(e) => denyCancelledApplication(e, regNum.regnumbeR_ID)}
                    />
                ) : action === 'confirm' && regNum.status == '4' ? (
                    <Button
                        label="Анулирай потвърждение"
                        icon="pi pi-undo"
                        severity="danger"
                        raised
                        className='btn-prim-red w-100-mob'
                        onClick={(e) => denyCancelledApplication(e, regNum.regnumbeR_ID)}
                    />
                ) : action === 'cancelAfterExpiredRanking' && regNum.status == '4' ? (
                    <Button
                        label="Отпиши"
                        icon="pi pi-times"
                        severity="danger"
                        raised
                        className='btn-prim-red w-100-mob'
                        onClick={(e) => CancelApplicationAfterExiredRanking(e, regNum.regnumbeR_ID)}
                    />
                ) : null
                }
            </div>
        </div>
    )
}